class Filter {
    static isEnabled(vin, device) {
        return Boolean(Filter.vinEnabled(vin) || Filter.deviceEnabled(device));
    }

    static vinEnabled(vin) {
        return Boolean(vin && vin.trim() && vin.trim().length === 17);
    }

    static deviceEnabled(device) {
        return Boolean(device && device.trim() && device.trim().length >= 16);
    }
}

export default Filter;
